
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"41.333","height":"66.667","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#cf0209"}},[_c('path',{attrs:{"d":"M225.8 129.6c-60.2 6.9-123.8 35.1-179 79.2C31 221.5 3.1 248.2 1.2 252.4c-2.7 5.9-1.2 8.4 13.6 22.7C86.2 344.8 173 384 256 384c82.2 0 170.4-39.4 239.2-106.9 16.9-16.5 18.3-18.7 15.6-24.7-1.9-4.2-29.8-30.9-45.6-43.6-55.8-44.6-119-72.4-180.3-79.3-16.2-1.8-43.1-1.8-59.1.1zm65.2 23.9c47.2 7.4 97.7 29.1 142.7 61.3 20.7 14.8 48.3 38.6 48.3 41.7 0 1.8-14.8 15.6-27.7 25.9-51.4 41.2-108.2 67.6-164.3 76.3-16.1 2.5-51.9 2.5-68 0-37.3-5.8-73.9-18.9-110-39.5-26.8-15.3-55.3-36.2-75.8-55.6l-7.3-7 7.3-7.1c18.3-17.8 45.7-38.4 70.2-52.9 41-24.2 81.9-39 122.6-44.2 13.8-1.7 47.7-1.1 62 1.1z"}}),_c('path',{attrs:{"d":"M242.8 176c-17.8 3.2-33.6 11.7-45.9 24.7-15.4 16.1-22.6 35.8-21.6 58.8.6 13.9 2.3 20.8 7.8 32.2 13.4 28 41.3 45.4 72.9 45.4 31.6 0 59.5-17.4 72.9-45.4 5.5-11.4 7.2-18.3 7.8-32.2.6-13.8-.7-21.8-5.6-33.9-9.2-22.9-29.2-40.8-53.3-47.6-8.2-2.4-27.2-3.5-35-2zm31.3 24.9c16.4 5.2 30.9 19.5 37 36.7 2.9 8.1 3.6 22.7 1.5 31.6-7.8 33.1-41.9 52.6-74.1 42.4-33-10.5-49.8-47.8-35.5-79.1 7.5-16.5 22.8-29.1 40-33 8.5-1.9 22.4-1.3 31.1 1.4z"}})])])
          )
        }
      }
    